import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "../../../css/Products/AddProduct.css";
import { addProductRequest, getCategoriesRequest } from "./AddProductRequest";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../SessionChecker/SessionChecker";

function AddProduct({ theme }) {

  const { t } = useTranslation();

  const [categories, setCategories] = useState([]);

  const [images, setImages] = useState([]);
  const [name, setName] = useState("");
  const [price, setPrice] = useState("");
  const [category, setCategory] = useState("");
  const [caption, setCaption] = useState("");

  const [nameError, setNameError] = useState(false);
  const [priceError, setPriceError] = useState(false);
  const [categoryError, setCategoryError] = useState(false);
  const [imagesError, setImagesError] = useState(false);

  const [requestStatus, setRequestStatus] = useState({
    loading: false,
    error: null,
  });

  const navigate = useNavigate();


  const handleImagesChange = (event) => {

    const selectedFiles = Array.from(event.target.files);

    const validFiles = selectedFiles.filter((file) => {
      return file.type === "image/png" || file.type === "image/jpeg";
    });

    const newImages = validFiles.map((file) => ({
      file: file,
      preview: URL.createObjectURL(file),
      id: crypto.randomUUID()
    }));

    setImages((prev) => [...prev, ...newImages]);

    if (newImages.length > 0) {
      setImagesError(false);
    }

    event.target.value = "";
  };

  const removeImage = (id) => {

    setImages((prev) => {

      const imageToRemove = prev.find(
        (image) => image.id === id
      );

      if (imageToRemove) {
        URL.revokeObjectURL(imageToRemove.preview);
      }

      return prev.filter(
        (image) => image.id !== id
      );
    });
  };

  const isFormValid =
    name.trim() !== "" &&
    price !== "" &&
    Number(price) > 0 &&
    category !== "" &&
    images.length > 0;


  const handleSubmit = async () => {
    let hasError = false;



    if (!name.trim()) {
      setNameError(true);
      hasError = true;
    }

    if (
      !price ||
      Number(price) <= 0
    ) {
      setPriceError(true);
      hasError = true;
    }

    if (!category) {
      setCategoryError(true);
      hasError = true;
    }

    if (images.length === 0) {
      setImagesError(true);
      hasError = true;
    }

    if (hasError) {
      return;
    }

    await addProductRequest(
      name.trim(),
      price,
      category,
      images,
      caption,
      setRequestStatus,
      navigate,
      currentUserUsername,
    );
  };   


  useEffect(() => {
    getCategoriesRequest(setCategories);
  }, []);

  const {currentUserUsername} = useContext(AuthContext);


  return (
    <div className="mainDiv">

      <div className={`headerDiv ${theme}`}>
        <div>{t("Add Product")}</div>
      </div>

      <div className="contentDiv">

        <div className={`addProductInfoDiv ${theme}`}>

          <div className="inputMainDiv">

            <div className="input_div">

              <div>{t("Name")}</div>

              <input
                className={`input dir_ltr ${theme} ${nameError ? "error" : ""}`}
                type="text"
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                  setNameError(false);
                }}
              />

              {nameError && (
                <div className="input_error_div">
                  {t("Please enter a name")}
                </div>
              )}

            </div>

            <div className="input_div">

              <div>{t("Price")}</div>

              <input
                className={`input dir_ltr ${theme} ${priceError ? "error" : ""}`}
                type="text"
                inputMode="numeric"
                value={price ? Number(price).toLocaleString("en-US") : ""}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  setPrice(value);
                  setPriceError(false);
                }}
              />

              {priceError && (
                <div className="input_error_div">
                  {t("Please enter a valid price")}
                </div>
              )}

            </div>


            <div className="input_div">

              <div>{t("Category")}</div>

              <select
                className={`info_select ${theme} ${categoryError ? "error" : ""}`}
                value={category}
                onChange={(e) => {
                  setCategory(e.target.value);
                  setCategoryError(false);
                }}
              >

                <option value="">
                  {t("Select Category")}
                </option>

                {categories.map((item) => (
                  <option
                    key={item.id}
                    value={item.id}
                  >
                    {item.name}
                  </option>
                ))}

              </select>

              {categoryError && (
                <div className="input_error_div">
                  {t("Please select a category")}
                </div>
              )}

            </div>


            <div className="input_div">

              <div>{t("Caption")}</div>

              <textarea
                className={`info_textarea green dir_ltr ${theme}`}
                value={caption}
                onChange={(e) => {
                  setCaption(e.target.value);
                }}
              />

            </div>


            {/* Images */}

            <div className="input_div">

              <div>{t("Images")}</div>

              <div
                className={`imagesContainer ${theme} ${imagesError ? "error" : ""
                  }`}
              >

                <label
                  htmlFor="productImages"
                  className="addImageItem"
                >
                  <span>+</span>
                </label>

                <input
                  id="productImages"
                  type="file"
                  accept="image/png,image/jpeg"
                  multiple
                  onChange={handleImagesChange}
                  className="imageFileInput"
                />

                {images.map((image) => (

                  <div
                    className="imagePreviewItem"
                    key={image.id}
                  >

                    <img
                      src={image.preview}
                      alt="preview"
                    />

                    <button
                      type="button"
                      onClick={() => removeImage(image.id)}
                      className="removeImageButton"
                    >

                    </button>

                  </div>

                ))}

              </div>

              {imagesError && (
                <div className="input_error_div">
                  {t("Please select at least one image")}
                </div>
              )}

            </div>

          </div>

          <div className="inputMainDiv">

            <button
              type="button"
              className={`submit_button ${theme} ${isFormValid ? "active" : ""}`}
              onClick={handleSubmit}
            >
              {requestStatus.loading
                ? <img src="/icons/loading.png" className="rotate" />
                : t("Confirm")
              }
            </button>

          </div>

        </div>

      </div>

    </div>
  );
}

export default AddProduct;